export default __webpack_public_path__ + "static/01-2dcbe172dca772ad94d570fea16ddb63.png";